import {
  SET_INFO,
  ADD_GALLERY_IMAGE,
  REMOVE_PROMOTION,
  ADD_PROMOTION,
  ADD_LINK_IMAGE,
  ADD_LINK,
  CHANGE_PORTAL,
  SET_PORTAL,
  UPDATE_PORTAL_SUCCESS,
  REMOVE_LINK,
  REMOVE_IMAGE_LIST_ITEM,
} from '../constants/index'

export default (state = {}, action) => {
  switch (action.type) {
    case SET_INFO:
      return {
        ...state,
        [action.key]: action.value,
      }
    case UPDATE_PORTAL_SUCCESS:
    case SET_PORTAL:
      return {
        ...state,
        syncVersion: undefined,
      }
    case ADD_LINK:
    case ADD_GALLERY_IMAGE:
    case ADD_LINK_IMAGE:
    case ADD_PROMOTION:
    case REMOVE_PROMOTION:
    case REMOVE_IMAGE_LIST_ITEM:
    case REMOVE_LINK:
    case CHANGE_PORTAL:
      return {
        ...state,
        syncVersion: state.syncVersion ? state.syncVersion + 1 : 1,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/info.js